// extracted by mini-css-extract-plugin
module.exports = {"companyLogo":"companyLogo_companyLogo__1e0QG","companyImgUrl":"companyLogo_companyImgUrl__QNbZs"};